import { featureFlags } from '@/featureFlags';
import { useCanUseAi } from '@/features/ai-assistant/hooks/useCanUseAi';
import { useRestaurantStore } from '@/stores/restaurant.store';

export function useAiAssistantAvailable(): boolean {
  const canUseAi = useCanUseAi();
  const aiChatEnabled = useRestaurantStore((s) => s.restaurantConfig?.aiChatEnabled ?? false);
  const paidByPartnerOrPlatform = useRestaurantStore((s) => {
    const ctx = s.userContext;
    if (!ctx) return false;
    if (ctx.systemRole === 'ADMIN') return true;
    return ctx.workers.some(
      (w) =>
        w.partnerGroupAccess &&
        w.restaurants.some((r) => r.restaurantId === s.selectedRestaurantId),
    );
  });
  return featureFlags.aiAssistant && canUseAi && (aiChatEnabled || paidByPartnerOrPlatform);
}
